import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';
import Button from '@react/react-spectrum/Button';
import { CONTACT_HELPDESK } from '../config/constants';

class SubmittedInReview extends Component{ 
    
    render(){
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                        <GridRow className = "padding-3 font">
                            <GridColumn >
                            <Translate value="uplevelRenewal.OnbrdInterimUplevelExistsMsg" />
                            </GridColumn>
                        </GridRow>
                        <GridRow className="padding-3">
                            <GridColumn>
                                <Button variant="primary" onClick={()=>{
                                    window.open(CONTACT_HELPDESK,"_blank");
                                }
                                }><Translate value="uplevelRenewal.Contact Helpdesk" /></Button>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
    }
}

export default SubmittedInReview;